import React from 'react';
import cn from 'classnames';
require("./Textarea-SecondLabel.css");
var styles = {
  "Root": "Textarea-SecondLabel-module-Root_xQ4",
  "required": "Textarea-SecondLabel-module-required_2ZC"
};
export const TextareaSecondLabel = ({
  title = '',
  required,
  maxCharactersLength = 100,
  className,
  value = '',
  showCharactersCounter,
  id
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Root, className)
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, title, required && /*#__PURE__*/React.createElement("sup", {
    className: styles.required
  }, "\u2731")), Boolean(maxCharactersLength) && showCharactersCounter && /*#__PURE__*/React.createElement("span", null, value.length, "/", maxCharactersLength));
};